import React from 'react';
import { ReactTyped } from "react-typed";
import c1 from './../../public/image/c1.jpg'
import c2 from './../../public/image/c2.jpg'
import c3 from './../../public/image/c3.jpg'
import { Carousel } from 'react-bootstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Helmet } from 'react-helmet';

const AboutUs = () => {
    return (
        <div className='px-sm-2'>
            <header>
                <Helmet>
                    <title> تماس با ما | فروشگاه البرز |البرز مارکت | قطعات کولر آبی | لوازم گازسوز | شیر الات | دودکش های ساختمانی | گروه صنعتی بازگانی البرز</title>
                    <meta name="description" content={`${"فروش عمده انواع قطعات کولر آبی و لوازم گازسوز و شیر آلات  | تولید کننده انواع دودکش های ساختمانی و ..."}`} />
                </Helmet>
                <h5 className="fw-bold text-dark text-center mb-3 rtl" >
                    <ReactTyped
                        strings={["گروه صنعتی بازرگانی البرز"]}
                        typeSpeed={80}
                        backSpeed={100}
                        backDelay={2000}
                        // loop
                        smartBackspace
                    />
                </h5>
            </header>
            <p style={{ textAlign: 'justify' }} className='alert alert-light'>
                « گروه صنعتی بازرگانی البرز از سال 1380 فعالیت خود را در زمینه تولید دودکش های ساختمانی
                و لوله بخاری و رنگ کوره ای آغاز کرده و در ادامه با فروش عمده لوازم  گرمایشی  ، سرمایشی ، شیرآلات ساختمانی ،
                اتصالات آبی و گازی و ... به فعالیت خود ادامه می دهد.
                »
            </p>
            <div style={{ width: '300px', height: '200px', borderRadius: '10px', overflow: 'hidden' }}
                className='mx-auto my-3'>
                <Carousel
                    controls={false}
                >
                    <Carousel.Item>
                        <LazyLoadImage
                            width={312}
                            height={200}
                            src={c1}
                            effect="blur"
                            style={{ objectFit: 'cover', borderRadius: '10px' }}
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <LazyLoadImage
                            width={312}
                            height={200}
                            src={c2}
                            style={{ objectFit: 'cover', borderRadius: '10px' }}
                            effect="blur"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <LazyLoadImage
                            width={312}
                            height={200}
                            src={c3}
                            style={{ objectFit: 'cover', borderRadius: '10px' }}
                            effect="blur"
                        />
                    </Carousel.Item>
                </Carousel>

            </div>
            <p style={{ textAlign: 'justify' }} className='alert alert-light'>
                <i className='fa fa-map-marker me-2'></i>
                آدرس : مشهد - جاده سیمان - خیابان رسالت - بین رسالت 107 و 109 - قطعه پنجم - فروشگاه البرز.
            </p>
        </div>
    );
}

export default AboutUs;